import { Switch, Route } from "react-router-dom";
import GestaoClientes from "../../Pages/Geral/GestaoClientes";
import AtendimentoHelpDesk from "../../Pages/HelpDesk/Atendimento";
import DashboardHelpDesk from "../../Pages/HelpDesk/Dashboard";
import Equipes from "../../Pages/HelpDesk/Equipes";
import GestaoAtendimentos from "../../Pages/HelpDesk/GestaoAtendimento";
import GestaoRespostas from "../../Pages/HelpDesk/GestaoRespostas";
import RelatoriosBIHelpDesk from "../../Pages/HelpDesk/RelatorioBI";
import ModuloADS from "../../Pages/ModuloAds";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import PesquisaSatisfacaoHelpdesk from "../../Pages/HelpDesk/PesquisaSatisfacao";
import GestaoTemplateHelpdesk from "../../Pages/HelpDesk/GestaoTemplate";
import ConfigurarTemplatesHelpdesk from "../../Pages/HelpDesk/GestaoTemplate/ConfigurarTemplates";
import FinalizarCriacaoTemplate from "../../Pages/HelpDesk/CadastrarTemplateTwilio/FinalizarCriacaoTemplate";
import CadastrarTemplateTwilio from "../../Pages/HelpDesk/CadastrarTemplateTwilio";
import RelatoriosBIHelpDeskCSAT from "../../Pages/HelpDesk/RelatorioBIHelpdeskCSAT";
import RelatoriosBIHelpDeskNPS from "../../Pages/HelpDesk/RelatorioBIHelpdeskNPS";

export default function RotasHelpDesk() {
    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.DASHBOARD.DS_PATH}
                component={DashboardHelpDesk}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.DASHBOARD.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.GESTAO_CLIENTES.DS_PATH}
                component={GestaoClientes}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.GESTAO_CLIENTES.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.GESTAO_EQUIPES.DS_PATH}
                component={Equipes}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.GESTAO_EQUIPES.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.GESTAO_ATENDIMENTOS.DS_PATH}
                component={GestaoAtendimentos}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.GESTAO_ATENDIMENTOS.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.WHATSAPP_BI.DS_PATH}
                component={RelatoriosBIHelpDesk}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.WHATSAPP_BI.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.WHATSAPP_BICSAT.DS_PATH}
                component={RelatoriosBIHelpDeskCSAT}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.WHATSAPP_BICSAT.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.WHATSAPP_BINPS.DS_PATH}
                component={RelatoriosBIHelpDeskNPS}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.WHATSAPP_BINPS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.ATENDIMENTO.DS_PATH}
                component={AtendimentoHelpDesk}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.ATENDIMENTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.GESTAO_RESPOSTAS.DS_PATH}
                component={GestaoRespostas}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.GESTAO_RESPOSTAS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.PESQUISA_SATISFACAO.DS_PATH}
                component={PesquisaSatisfacaoHelpdesk}
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.PESQUISA_SATISFACAO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES.DS_PATH}
                component={GestaoTemplateHelpdesk}
                exact
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.CONFIGURAR_TEMPLATES.DS_PATH}
                exact
                component={ConfigurarTemplatesHelpdesk}
                isPrivate
            />

            <PrivatedRoute
                path={ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES_TWILIO.DS_PATH}
                component={CadastrarTemplateTwilio}
                exact
                isPrivate
                idModulo={ACESSOS.HELPDESK.ID_MODULO}
                idTela={ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES_TWILIO.ID_TELA}
            />

            <PrivatedRoute
                path={
                    ACESSOS.HELPDESK.TELAS.CONFIGURAR_TEMPLATES_TWILIO.DS_PATH
                }
                exact
                component={FinalizarCriacaoTemplate}
                isPrivate
            />
            <Route path="/HelpDesk/:idModulo/" exact component={ModuloADS} />
        </Switch>
    );
}
